import React from 'react'
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import './index.css'

interface FormInputPhoneProps {
  Form: any;
  handlePhoneNumberChange: (phone: string, data: any) => void;
  userCountryCode?: string;
  userContactNumber?: string;
  label?: React.ReactNode;
  inputStyle?: React.CSSProperties;
}

const FormInputPhone: React.FC<FormInputPhoneProps> = ({
  Form,
  handlePhoneNumberChange,
  userCountryCode,
  userContactNumber,
  label,
  inputStyle = {},
}) => {
  return (
    <div className="__formInputWrapper">
      <Form.Item className="v2FormInput" label={<React.Fragment>{label}</React.Fragment>}>
        <PhoneInput
          inputStyle={inputStyle}
          dropdownClass="contactNumberCode"
          inputClass="contactNumberInput"
          buttonClass="contactNumberButton"
          enableSearch
          country={userCountryCode}
          countryCodeEditable={false}
          value={userContactNumber}
          onChange={(phone: string, data: any) => handlePhoneNumberChange(phone, data)}
        />
      </Form.Item>
    </div>
  )
}

export default FormInputPhone
